import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import ConfirmDialog from 'components/dialogs/ConfirmDialog';
import globalMessages from 'translations/messages/global-messages';

const LoginInvitationDialog = ({ email, onSubmit }) => {
  const intl = useIntl();
  const history = useHistory();
  const [showDialog, setShowDialog] = useState(true);

  const handleClose = () => {
    setShowDialog(false);
    history.replace('/');
  };

  const handleSubmit = () => {
    setShowDialog(false);
    onSubmit();
  };

  return (
    <ConfirmDialog
      displayCancel
      open={showDialog}
      title={intl.formatMessage(globalMessages.invitation_link_title)}
      message={intl.formatMessage(globalMessages.invitation_deeplink_info, { email })}
      areYouSureLabel=" "
      submitLabel={intl.formatMessage(globalMessages.sign_out)}
      onClose={handleClose}
      onSubmit={handleSubmit}
    />
  );
};

LoginInvitationDialog.propTypes = {
  email: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default LoginInvitationDialog;
